import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IFormOptions } from '@modeso/aumico-lib-core-fe';
import { IFinancialLineItemDTO } from '@modeso/types__aumico-lib-settings-be';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Subject, filter } from 'rxjs';
import { IfinancialLineItemFormData } from '../../interfaces/financial-line-item-form-data.interface';
import { getDebug, getTag } from '../../utils/debugUtil';

const filename =
    'projects/aumico-lib-settings-fe/src/lib/components/financial-line-item-form/financial-line-item-form.component.ts';
const debug = getDebug(filename);
const TAG = getTag(filename);
@UntilDestroy()
@Component({
    selector: 'settings-financial-line-item-form',
    templateUrl: './financial-line-item-form.dialog.html',
    styleUrls: ['./financial-line-item-form.dialog.scss'],
})
export class FinancialLineItemFormDialog implements OnInit, OnDestroy {
    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: IfinancialLineItemFormData,
    ) {}

    @Input() languages: string[] = ['de-ch', 'en-us'];

    public savePressed = new Subject<IFinancialLineItemDTO>();

    options: IFormOptions;

    protected subscriptions = [];
    public nameAlreadyExistsError = false;

    public ngOnInit(): void {
        this.data.errorMessage
            .pipe(
                filter(
                    (financialLineItemResponse) =>
                        financialLineItemResponse != null && financialLineItemResponse.status === 409,
                ),
                untilDestroyed(this),
            )
            .subscribe(() => {
                this.nameAlreadyExistsError = true;
            });
    }

    public savePressedEventHandler(result: IFinancialLineItemDTO): void {
        debug('result of the form');
        debug(result);
        this.savePressed.next(result);
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach((subscribe) => {
            subscribe.unsubscribe();
        });
    }
}
